import { useState } from "react";
import httpService from "../services/httpService"; // your axios wrapper

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import { Link } from "react-router-dom";

const Sso = () => {
    return (
        <Container className="d-flex justify-content-center align-items-center min-vh-100">
            <Card style={{
                width: '50%',
                overflow: 'hidden',
                margin: 0
            }}>
                <Row className="g-0">
                    <Col>
                        <div className='p-3'>
                            <h3>SSO</h3>
                            <Link to="/signup">Go to Sign Up</Link> <br/>
                            <Link to="/login">Go to Login</Link>
                        </div>
                    </Col>
                </Row>
            </Card>
        </Container>
    );
};

export default Sso;
